import { call, put } from 'redux-saga/effects';

import {
  axiosAuthInstance,
  API_END_POINTS,
} from 'api';
import { MESSAGES } from 'appconstants';

import generateQuery from 'utils/generateQuery';

import {
  SERVICEDETAILS,
  LOADING,
  NOTIFICATION,
} from '../actionTypes';

const fetchServiceDetails = async gid => axiosAuthInstance.get(`${API_END_POINTS.GET_SERVICES}/${gid}`);

const patchServiceDetails = async ({ gid, params }) => axiosAuthInstance.patch(`${API_END_POINTS.INTERNAL_SERVICE}/${gid}`, params);

const fetchServiceTimeLine = async gid => axiosAuthInstance.get(`${API_END_POINTS.GET_SERVICES}/${gid}/service-timeline`);

const fetchFieldAgent = async (payload) => {
  const query = generateQuery(payload.currentPage);
  const sorting = payload.sortParams ? payload.sortParams : '&sortBy=createdAt&direction=DESC';
  return axiosAuthInstance.get(`${API_END_POINTS.INTERNAL_FIELDAGENT}${query}${sorting}`);
};

export function* getServiceDetails(action) {
  try {
    yield put({ type: LOADING.SET });
    const { data: { entity } } = yield call(fetchServiceDetails, action.payload);
    yield put({ type: SERVICEDETAILS.SUCCESS, payload: entity });
  } catch (e) {
    yield put({ type: SERVICEDETAILS.FAILED, payload: e.response.data });
    if (e.response.status !== 401) {
      yield put({
        type: NOTIFICATION.ERROR,
        payload: e.response.data ? e.response.data.message : MESSAGES.API_ERROR,
      });
    }
  } finally {
    yield put({ type: LOADING.UNSET });
  }
}

export function* getFieldAgent(action) {
  try {
    yield put({ type: LOADING.SET });
    const { data: { entity } } = yield call(fetchFieldAgent, action.payload);
    yield put({ type: SERVICEDETAILS.FIELDAGENT_SUCCESS, payload: entity });
  } catch (e) {
    yield put({ type: SERVICEDETAILS.FIELDAGENT_FAILED, payload: e.response.data });
    if (e.response.status !== 401) {
      yield put({
        type: NOTIFICATION.ERROR,
        payload: e.response.data ? e.response.data.message : MESSAGES.API_ERROR,
      });
    }
  } finally {
    yield put({ type: LOADING.UNSET });
  }
}

export function* updateServiceDetails(action) {
  try {
    yield put({ type: LOADING.SUBMITTING });
    yield put({ type: LOADING.VALIDATING });
    yield call(patchServiceDetails, action.payload);
    const { data: { entity } } = yield call(fetchServiceDetails, action.payload.gid);
    yield put({ type: SERVICEDETAILS.SUCCESS, payload: entity });
    const { data } = yield call(fetchServiceTimeLine, action.payload.gid);
    yield put({ type: SERVICEDETAILS.SUCCESS_TIMELINE, payload: data.entity });
    yield put({
      type: NOTIFICATION.SUCCESS,
      payload: MESSAGES.SERVICES.UPDATE_SUCCESS,
    });
    yield put({ type: LOADING.VALIDATED });
  } catch (e) {
    if (e.response.status !== 401) {
      yield put({
        type: NOTIFICATION.ERROR,
        payload: e.response.data ? e.response.data.message : MESSAGES.API_ERROR,
      });
    }
  } finally {
    yield put({ type: LOADING.SUBMITTED });
  }
}

export function* getServiceTimeLine(action) {
  try {
    yield put({ type: LOADING.SET });
    const { data: { entity } } = yield call(fetchServiceTimeLine, action.payload);
    yield put({ type: SERVICEDETAILS.SUCCESS_TIMELINE, payload: entity });
  } catch (e) {
    yield put({ type: SERVICEDETAILS.FAILED, payload: e.response.data });
    if (e.response.status !== 401) {
      yield put({
        type: NOTIFICATION.ERROR,
        payload: e.response.data ? e.response.data.message : MESSAGES.API_ERROR,
      });
    }
  } finally {
    yield put({ type: LOADING.UNSET });
  }
}
